import { request } from "../utils/request";

const resource = {
  getCoursewareList(data) {
    return request({
      method: "POST",
      url: "/api/courseware/CoursewareManage/getCoursewareList",
      data
    });
  },
    getVideoList(data) {
        return request({
          method: "POST",
          url: "/api/courseware/VideoManage/getVideoList",
          data
        });
      },
      getVideoURL(data) {
        return request({
          method: "POST",
          url: "/api/courseware/VideoManage/videourl",
          data
        });
      },
      getnoVideoURL(data) {
        return request({
          method: "POST",
          url: "/api/courseware/VideoManage/noAuthVideourl",
          data
        });
      },
      checkfilename(data) {  //上传前校验是否上传过
        return request({
          method: "POST",
          url: "/api/courseware/VideoManage/checkfilename",
          data
        });
      },
      getOSS_STS(data) {  //请求签证ID 视频
        return request({
          method: "POST",
          url: "/api/courseware/VideoManage/OSS-STS",
          data
        });
      },
      // 课件请求签证ID 
      getCoursewareOSS_STS(data) {  //请求签证ID
        return request({
          method: "POST",
          url: "/api/courseware/coursewareManage/OSS-STS",
          data
        });
      },
      createVideo(data) {  //创建视频
        return request({
          method: "POST",
          url: "/api/courseware/VideoManage/createVideo",
          data
        });
      },
      createCourseware(data){  //创建课件
        return request({
          method: "POST",
          url: "/api/courseware/CoursewareManage/createCourseware",
          data
        });
      },
      deleteVideo(data) {  //删除单个视频
        return request({
          method: "POST",
          url: "/api/courseware/VideoManage/delete",
          data
        });
      },
      // 批量删除 
      deleteVideoArr(data) {  //删除单个视频
        return request({
          method: "POST",
          url: "/api/courseware/VideoManage/deleteArr",
          data
        });
      },
      getVideo(data){
        return request({
          method: "POST",
          url: "/api/courseware/VideoManage/getVideo",
          data
        });
      },
      getCourseware(data){
        return request({
          method: "POST",
          url: "/api/courseware/CoursewareManage/getCourseware",
          data
        });
      },
      SaveVideoInfo(data){
        return request({
          method: "POST",
          url: "/api/courseware/VideoManage/SaveVideoInfo",
          data
        });
      },
      SaveCoursewareInfo(data){
        return request({
          method: "POST",
          url: "/api/courseware/CoursewareManage/SaveCoursewareInfo",
          data
        });
      },
      // 课件管理删除
      deleteCourseware(data) {  //删除单个
        return request({
          method: "POST",
          url: "/api/courseware/CoursewareManage/deleteCourseware",
          data
        });
      },
      // 批量
      deleteCoursewareArr(data) {  //批量删除
        return request({
          method: "POST",
          url: "/api/courseware/CoursewareManage/deleteCoursewareArr",
          data
        });
      },
      //视频全体进度占比
      videoProgress(data){
        return request({
          method: "POST",
          url: "/api/courseware/ProgressStatistics/videoProgress",
          data
        });
      },
      //视频进行中占比分析
      videoComplete(data){
        return request({
          method: "POST",
          url: "/api/courseware/ProgressStatistics/videoComplete",
          data
        });
      },
      //视频科室进度对比
      videoDepartment(data){
        return request({
          method: "POST",
          url: "/api/courseware/ProgressStatistics/videoDepartment",
          data
        });
      },
      //查询考生详情列表
      videoDetailList(data){
        return request({
          method: "POST",
          url: "/api/courseware/ProgressStatistics/videoDetailList",
          data
        });
      },
       //课件全体进度占比
       courseProgress(data){
        return request({
          method: "POST",
          url: "/api/courseware/CourseProgressStatistics/courseProgress",
          data
        });
      },
      //课件进行中占比分析
      courseComplete(data){
        return request({
          method: "POST",
          url: "/api/courseware/CourseProgressStatistics/courseComplete",
          data
        });
      },
      //课件科室进度对比
      courseDepartment(data){
        return request({
          method: "POST",
          url: "/api/courseware/CourseProgressStatistics/courseDepartment",
          data
        });
      },
      //查询考生详情列表
      courseDetailList(data){
        return request({
          method: "POST",
          url: "/api/courseware/CourseProgressStatistics/courseDetailList",
          data
        });
      },
      //查询单个考生每次的学习情况 课件
      courseDetailById(data){
        return request({
          method: "POST",
          url: "/api/courseware/CourseProgressStatistics/courseDetailById",
          data
        });
      },
       //查询单个考生每次的学习情况 视频
       videoDetailById(data){
        return request({
          method: "POST",
          url: "/api/courseware/ProgressStatistics/videoDetailById",
          data
        });
      },
      //导出视频用户的数据表格
      videoImportExcel(data){
        return request({
          method: "POST",
          url: "/api/courseware/ProgressStatistics/videoImportExcel",
          data,
          responseType: 'blob',
        });
      },
       //导出课件用户的数据表格
       courseImportExcel(data){
        return request({
          method: "POST",
          url: "/api/courseware/CourseProgressStatistics/courseImportExcel",
          data,
          responseType: 'blob',
        });
      },
}
export default resource;